// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Shares\ApiShare.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { SharingToken, SharingTokenData, SharingTokenOptions } from 'data/models/SharingToken';
import { ShareScope } from 'server/enums/ShareScope';
import { ShareType } from 'server/enums/ShareType';

// ShareData is the class that Share serializes to/from
export interface ShareData {
    Id : number;
    Url : string | null;
	
    Organization : OrganizationData | null;
    OrganizationId : number;
    Token : SharingTokenData | null;
    TokenId : number;
    User : PCUserData | null;
    UserId : number;
	
    Guid : /* GUID */ string;
    Scope : ShareScope;
    Type : ShareType;
}

// ShareOptions is the class which may be passed to the Share constructor to define optional initial data values
export interface ShareOptions {
    Id : number;
    Url? : string | null;
	
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
    Token? : SharingTokenOptions | null;
    TokenId? : number;
    User? : PCUserOptions | null;
    UserId? : number;
	
    Guid? : /* GUID */ string;
    Scope? : ShareScope;
    Type? : ShareType;
}

export class Share {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
    public Token : DataSignal<SharingToken | null>;
    public TokenId : DataSignal<number>;
    public User : DataSignal<PCUser | null>;
    public UserId : DataSignal<number>;
	
    public Guid : DataSignal<string>;
    public Scope : DataSignal<ShareScope>;
    public Type : DataSignal<ShareType>;

    constructor();
    constructor(data : ShareOptions);
    constructor(data: ShareOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Token = S.value<SharingToken | null>(null);
        this.TokenId = jsonableObservable(S.value<number>(data && data.TokenId !== undefined ? data.TokenId : 0));
        this.User = S.value<PCUser | null>(null);
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Scope = jsonableObservable(S.value<ShareScope>(data && data.Scope !== undefined ? data.Scope : 0));
        this.Type = jsonableObservable(S.value<ShareType>(data && data.Type !== undefined ? data.Type : 0));
    }

    static key(obj : Share) {
        return obj.Id();
    }
    
    static dataKey(obj : ShareOptions) {
        return obj.Id;
    }

    static update(obj : Share, data : ShareOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.TokenId !== undefined) obj.TokenId(data.TokenId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Scope !== undefined) obj.Scope(data.Scope);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Share.ts